export default __webpack_public_path__ + "static/media/mainz_xl.9b863c09.jpg";